import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AdminProvider } from './contexts/AdminContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AnalyticsTracker from './components/AnalyticsTracker';
import { ALL_SEO_SLUGS } from './data/seoPages';
import './styles/public-site.css';

const AdminPanel = lazy(() => import('./components/AdminPanel'));
const TaxiCalculator = lazy(() => import('./components/TaxiCalculator'));
const BlogListPage = lazy(() => import('./components/BlogListPage'));
const BlogArticlePage = lazy(() => import('./components/BlogArticlePage'));
const PrivacyPolicyPage = lazy(() => import('./components/PrivacyPolicyPage'));
const SeoLandingPage = lazy(() => import('./components/SeoLandingPage'));

function RouteFallback() {
  return <div className="route-loading" aria-live="polite">Chargement…</div>;
}

function PublicSiteLayout({ children }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="site-v2">
      {!isHomePage && (
        <div className="magix-mesh" aria-hidden="true">
          <div className="magix-orb magix-orb-1" />
          <div className="magix-orb magix-orb-2" />
          <div className="magix-orb magix-orb-3" />
          <div className="magix-grid-lines" />
        </div>
      )}
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AdminProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <div className="App">
            <AnalyticsTracker />
            <Routes>
              {/* Route Admin */}
              <Route path="/admin/*" element={
                <Suspense fallback={<RouteFallback />}>
                  <AdminPanel />
                </Suspense>
              } />

              {/* Routes publiques */}
              <Route
                path="/*"
                element={
                  <PublicSiteLayout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="calculateur" element={
                          <Suspense fallback={<RouteFallback />}>
                            <TaxiCalculator />
                          </Suspense>
                        } />
                        <Route path="blog" element={
                          <Suspense fallback={<RouteFallback />}>
                            <BlogListPage />
                          </Suspense>
                        } />
                        <Route path="blog/:slug" element={
                          <Suspense fallback={<RouteFallback />}>
                            <BlogArticlePage />
                          </Suspense>
                        } />
                        <Route path="politique-de-confidentialite" element={
                          <Suspense fallback={<RouteFallback />}>
                            <PrivacyPolicyPage />
                          </Suspense>
                        } />
                        {ALL_SEO_SLUGS.map((seoSlug) => (
                          <Route
                            key={seoSlug}
                            path={seoSlug}
                            element={
                              <Suspense fallback={<RouteFallback />}>
                                <SeoLandingPage />
                              </Suspense>
                            }
                          />
                        ))}
                        <Route path="*" element={
                          <section className="section-block">
                            <div className="container">
                              <h1>Page introuvable</h1>
                              <p>Cette page n’existe pas ou a été déplacée.</p>
                              <a href="/">Retour à l’accueil</a>
                            </div>
                          </section>
                        } />
                    </Routes>
                  </PublicSiteLayout>
                }
              />
            </Routes>
          </div>
        </Router>
      </AdminProvider>
    </HelmetProvider>
  );
}

export default App;
